export enum LeadCancellationReason {
  PRICE = 'price',
  NO_FINANCIAL_CONDITION = 'no_financial_condition',
  NO_TIME = 'no_time',
  NOT_A_PRIORITY_NOW = 'not_a_priority_now',
  STOPPED_RESPONDING = 'stopped_responding',
  NO_INTEREST = 'no_interest',
  HEALTH_ISSUE = 'health_issue',
  BOUGHT_COMPETITOR_PRODUCT = 'bought_competitor_product',
  INVALID_CONTACT = 'invalid_contact',
  PREFERS_PERSONAL_TRAINER = 'prefers_personal_trainer',
}

export const LEAD_CANCELLATION_REASON_OPTIONS = [
  { value: LeadCancellationReason.PRICE, label: 'Preço' },
  { value: LeadCancellationReason.NO_FINANCIAL_CONDITION, label: 'Sem condição financeira' },
  { value: LeadCancellationReason.NO_TIME, label: 'Sem tempo' },
  { value: LeadCancellationReason.NOT_A_PRIORITY_NOW, label: 'Não é prioridade no momento' },
  { value: LeadCancellationReason.STOPPED_RESPONDING, label: 'Parou de responder' },
  { value: LeadCancellationReason.NO_INTEREST, label: 'Não teve interesse' },
  { value: LeadCancellationReason.HEALTH_ISSUE, label: 'Questão de saúde' },
  { value: LeadCancellationReason.BOUGHT_COMPETITOR_PRODUCT, label: 'Comprou outro produto/concorrente' },
  { value: LeadCancellationReason.INVALID_CONTACT, label: 'Contato inválido' },
  { value: LeadCancellationReason.PREFERS_PERSONAL_TRAINER, label: 'Prefere Personal' },
];

const LEAD_CANCELLATION_REASON_LABELS = Object.fromEntries(
  LEAD_CANCELLATION_REASON_OPTIONS.map((option) => [option.value, option.label]),
) as Record<LeadCancellationReason, string>;

export const LEAD_CANCELLATION_REASON_VALUES = new Set<string>(
  LEAD_CANCELLATION_REASON_OPTIONS.map((option) => option.value),
);

export function getLeadCancellationReasonLabel(
  value: string | null | undefined,
): string {
  if (!value) {
    return '—';
  }

  return LEAD_CANCELLATION_REASON_LABELS[value as LeadCancellationReason] ?? value;
}

export function isLeadCancellationReason(value: string): value is LeadCancellationReason {
  return LEAD_CANCELLATION_REASON_VALUES.has(value);
}
